import React, {forwardRef} from 'react'
import Slider, {Settings} from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import * as s from './carousel.styles'

const Carousel = forwardRef<Slider, React.PropsWithChildren<Settings>>(
    ({children, ...props}, ref) => {
        const defaultSettings: Settings = {
            autoplaySpeed: 4500,
            dots: true,
            autoplay: true,
            arrows: false,
            pauseOnFocus: true,
            pauseOnDotsHover: true,
            pauseOnHover: true,
        }

        return (
            <s.Wrapper>
                <Slider ref={ref} {...defaultSettings} {...props}>
                    {children}
                </Slider>
            </s.Wrapper>
        )
    }
)

export default Carousel
